import React, { PureComponent } from "react";
import moment from "moment";
import DatePicker from "react-datepicker";
import { Button } from "components/buttons";
import { general as texts } from "assets/strings/texts";

export class MovementsFormModel extends PureComponent {
  render() {
    let {
      viewState,
      phoneView,
      searchType,
      searchFilter,
      filterEnable = true,
      fromDate,
      endDate,
      collapsed,
      toggleCollapse,
      handleSearchTypeButtons,
      handleSearchFilterButtons,
      handleFromDate,
      handleEndDate,
      handleSubmit,
      className,
    } = this.props;
    return (
      <form className={className}>
        {viewState === "movements_search_loading" && (
          <div className="ui active loader"></div>
        )}
        <div className={`collapsed ${collapsed ? "true" : "false"}`}>
          <div className="selectors">
            <Button
              value="latests"
              pressed={searchType === "latests"}
              color={searchType === "latests" ? "blue" : "grey_1"}
              disabled={viewState === "movements_search_loading"}
              onClick={handleSearchTypeButtons}
            >
              {texts.latests}
            </Button>
            <Button
              value="dateRange"
              pressed={searchType === "dateRange"}
              color={searchType === "dateRange" ? "blue" : "grey_1"}
              disabled={viewState === "movements_search_loading"}
              onClick={handleSearchTypeButtons}
            >
              {texts.dateRange}
            </Button>
          </div>
          {searchType === "dateRange" && (
            <div className="date-pickers">
              <DatePicker
                className="date-picker"
                placeholderText={texts.from}
                dateFormat={texts.shortDateFormat}
                disabled={viewState === "movements_search_loading"}
                showMonthDropdown
                showYearDropdown
                todayButton={texts.today}
                isClearable
                withPortal={phoneView}
                selected={fromDate}
                maxDate={
                  endDate ? moment(endDate).subtract(23, "hours") : moment()
                }
                onChange={handleFromDate}
              />
              <p>/</p>
              <DatePicker
                className="date-picker"
                placeholderText={texts.to}
                dateFormat={texts.shortDateFormat}
                disabled={viewState === "movements_search_loading"}
                popperPlacement="bottom-end"
                showMonthDropdown
                showYearDropdown
                todayButton={texts.today}
                isClearable
                withPortal={phoneView}
                selected={
                  endDate ? moment(endDate).subtract(23, "hours") : null
                }
                minDate={fromDate ? moment(fromDate).add(23, "hours") : null}
                maxDate={moment()}
                onChange={handleEndDate}
              />
            </div>
          )}
          {filterEnable && (
            <div className="selectors">
              <Button
                value={searchFilter === "incomes" ? "" : "incomes"}
                pressed={searchFilter === "incomes"}
                color={searchFilter === "incomes" ? "blue" : "grey_1"}
                disabled={viewState === "movements_search_loading"}
                onClick={handleSearchFilterButtons}
              >
                {texts.income}
              </Button>
              <Button
                value={searchFilter === "expenditures" ? "" : "expenditures"}
                pressed={searchFilter === "expenditures"}
                color={searchFilter === "expenditures" ? "blue" : "grey_1"}
                disabled={viewState === "movements_search_loading"}
                onClick={handleSearchFilterButtons}
              >
                {texts.expenditures}
              </Button>
            </div>
          )}
          <Button
            color="grey"
            disabled={viewState === "movements_search_loading"}
            onClick={handleSubmit}
          >
            Buscar
          </Button>
        </div>
        {typeof toggleCollapse === "function" && (
          <div className="collapse-button" onClick={toggleCollapse}>
            {collapsed ? (
              <i className="chevron down icon"></i>
            ) : (
              <i className="chevron up icon"></i>
            )}
          </div>
        )}
      </form>
    );
  }
}

export function handleSearchTypeButtons(event) {
  event.preventDefault();
  this.setState({ searchType: event.target.value });
}

export function handleSearchFilterButtons(event) {
  event.preventDefault();
  this.setState({ searchFilter: event.target.value });
}

export function handleSearchCurrencyButtons(event) {
  event.preventDefault();
  this.setState({ searchCurrency: event.target.value });
}

export function handleFromDate(date) {
  this.setState({ fromDate: date });
}

export function handleEndDate(date) {
  if (date) {
    // If the date exists add 23 hours
    this.setState({ endDate: moment(date).add(23, "hours") });
  } else {
    // If the date is null, save it like that
    this.setState({ endDate: date });
  }
}
export function handleStatusButtons(event) {
  event.preventDefault();
  let status = event.target.value;
  this.setState((prevState) => ({
    [status]: !prevState[status],
  }));
}
